import React from "react";

import { Link } from "react-router";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { withRouter } from "react-router";

import PublicPage from "./public-page";

const PasswordResetSent = () => {
  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => {
        const email = profileContainer.getPasswordResetAttempt();

        return (
          <PublicPage>
            <div className="content text-center align-items-center">
              <h3>Request Sent</h3>
              <p>Your password reset instructions have been sent to {email}.</p>
              <hr className="mh-3 w-100" />

              <div className="mt-3 w-100">
                <Link
                  className="btn btn-primary btn-xl w-100 text-uppercase"
                  to="/">
                  Sign In
                </Link>
              </div>
            </div>
            <div className="footer text-center mt-5">
              <Link className="text-uppercase" to="/">
                Login
              </Link>
            </div>
          </PublicPage>
        );
      }}
    </Subscribe>
  );
};

export default withRouter(PasswordResetSent);
